<!-- container-xxl -->
<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<!-- app e-commerce details start -->
		<section class="app-ecommerce-details">
			<!-- <div class="card"> -->
				<!-- Related Products starts -->
				<div>
					<div id="stepper1" class="bs-stepper horizontal-wizard-example">
						<div class="bs-stepper-header">
							<div class="step" data-target="#format1">
								<button class="step-trigger">
									<span class="bs-stepper-box">1</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 1</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format 1</span
										>
									</span>
								</button>
							</div>
							<div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div>
							<div class="step" data-target="#format2">
								<button class="step-trigger">
									<span class="bs-stepper-box">2</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 2</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 2</span
										>
									</span>
								</button>
							</div>
							<div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div>
							<div class="step" data-target="#format3">
								<button class="step-trigger">
									<span class="bs-stepper-box">3</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 3</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 3</span
										>
									</span>
								</button>
							</div>
							<div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div>
							<div class="step" data-target="#format4">
								<button class="step-trigger">
									<span class="bs-stepper-box">4</span>
									<span class="bs-stepper-label">
										<span class="bs-stepper-title">Proposal Format - 4</span>
										<span class="bs-stepper-subtitle"
											>Setup Proposal Format - 4</span
										>
									</span>
								</button>
							</div>
							<div class="line">
								<i data-feather="chevron-right" class="font-medium-2"></i>
							</div>
							<!-- <div class="step" data-target="#format5">
				<button class="step-trigger">
					<span class="bs-stepper-box">5</span>
					<span class="bs-stepper-label">
					<span class="bs-stepper-title">Proposal Format - 5</span>
					<span class="bs-stepper-subtitle">Setup Proposal Format - 5</span>
					</span>
				</button>
				</div> -->
						</div>
						<div class="bs-stepper-content">
							<div id="format1" class="content">
								<form [formGroup]="format1" autocomplete="off">
									<!-- <div class="content-header">
					<h5 class="mb-0">Proposal Format - 1</h5>
					<small class="text-muted">Fill-up the Details.</small>
					</div> -->
					<fieldset class="border" style="padding: 0.7rem">
						<legend class="w-auto">
							<h5 style="margin-top: 7px">Project Details</h5>
						</legend>
						<div class="row">
							<div class="form-group col-md-4">
								<label class="form-label" for="SubjectArea">Subject Area <span class="required-asterisk">*</span></label>
								<div class="demo-inline-spacing" style="margin-top: -15px;">
									<div class="custom-control custom-checkbox" *ngFor="let a of this.subjectAreaType; let $index=index">
										<input type="checkbox" id="SubjectArea{{$index+1}}" name="SubjectArea{{$index+1}}"
											class="custom-control-input"  [value]="a.item_id" (change)="onCheckboxChange($event)" 
											[checked] = 'a.isSelected' [class.error]="!f1.SubjectArea.valid && submitted"/>
										<label class="custom-control-label" for="SubjectArea{{$index + 1}}">{{a.item_text}}</label>
									</div>
								</div>
								<span *ngIf="submitted && f1.SubjectArea.invalid" class="invalid-form">
									<small class="form-text text-danger" *ngIf="f1.SubjectArea.errors.required">please select atleast one subject area!</small>
								</span>
							</div>

							<!-- <div class="form-group col-md-4">
								<label class="form-label" for="SubjectArea">Subject Area <span class="required-asterisk">*</span></label>
								<div class="demo-inline-spacing" style="margin-top: -15px;">
									<div class="custom-control custom-checkbox">
										<input type="checkbox" id="SubjectArea6" name="SubjectArea6"
											class="custom-control-input" [value]="10006" (change)="onCheckboxChange($event)" 
											checked = 'checked' [class.error]="!f1.SubjectArea.valid && submitted"/>
										<label class="custom-control-label" for="SubjectArea6">Hydrogen Energy</label>
									</div>
								</div>
								<span *ngIf="submitted && f1.SubjectArea.invalid" class="invalid-form">
									<small class="form-text text-danger" *ngIf="f1.SubjectArea.errors.required">please select atleast one subject area!</small>
								</span>
							</div> -->
							
							<div class="form-group col-md-4">
								<label class="form-label" for="areaOfResearch"
									>Area of Research</label
								>
								<span class="required-asterisk">*</span>
					
								<ng-select
									[items]="areaOfResearch"
									[(ngModel)]="selected"
									bindLabel="name"
									bindValue="id"
									placeholder="Category of the Area Of Research(s)"
									multiple="multiple"
									[class.error]="
										!f1.AreaOfResearch.valid && submitted
									"
									formControlName="AreaOfResearch"
									(change)="
										onareaOfResearchOptionsSelected(selected)
									"
									[(ngModel)]="selected"
								>
								</ng-select>
								<span
									*ngIf="submitted && f1.AreaOfResearch.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.AreaOfResearch.errors.required"
										>This field is required!</small
									>
								</span>
							</div>
							<div class="form-group col-md-4" *ngIf="displayOtherField">
								<label class="form-label" for="otherAreaofResearch"
									>Other Area of Research</label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="OtherAreaofResearch"
									type="text"
									
									name="otherAreaofResearch"
									id="otherAreaofResearch"
									class="form-control"
									[ngClass]="{
										'is-invalid':
											submitted && !f1.OtherAreaofResearch.valid
									}"
									placeholder="Other Area of Research"
									
								/>
								<span
									*ngIf="submitted && f1.OtherAreaofResearch.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.OtherAreaofResearch.errors.required"
										>This field is required!</small
									>
								</span>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-md-3">
								<label class="form-label" for="projectTitle"
									>Project Title</label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="ProjectTitle"
									type="text"
									name="projectTitle"
									id="projectTitle"
									class="form-control"
									[ngClass]="{
										'is-invalid': submitted && !f1.ProjectTitle.valid
									}"
									placeholder="Project title"
								/>
								<span
									*ngIf="submitted && f1.ProjectTitle.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.ProjectTitle.errors.required"
										>This field is required!</small
									>
									<small
										class="form-text text-danger"
										*ngIf="f1.ProjectTitle.errors.pattern"
										>This field contain atleast one alphanumerical
										value!</small
									>
								</span>
							</div>
							<div class="form-group col-md-3">
								<label class="form-label" for="projectType"
									>Project Type</label
								>
								<span class="required-asterisk">*</span>
								<ng-select
									[items]="projectType"
									bindLabel="projectTypeName"
									bindValue="projectTypeID"
									[class.error]="!f1.ProjectType.valid && submitted"
									formControlName="ProjectType"
									placeholder="Project Type"
								>
								</ng-select>
								<span
									*ngIf="submitted && f1.ProjectType.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.ProjectType.errors.required"
										>This field is required!</small
									>
								</span>
							</div>
							<div class="form-group col-md-3">
								<label class="form-label" for="duration"
									>Duration (in Months)</label
								>
								<span class="required-asterisk">*</span>
								<input
									formControlName="Duration"
									type="text"
									name="duration"
									id="duration"
									class="form-control"
									(change)="setNoofYears(f1.Duration.value, true)"
									placeholder="Duration"
									[ngClass]="{
										'is-invalid': submitted && !f1.Duration.valid
									}"
									[mask]="'^([1-9]\\d*|0)$'"
									maxlength="4"
								/>
								<span
									*ngIf="submitted && f1.Duration.invalid"
									class="invalid-form"
								>
									<small
										class="form-text text-danger"
										*ngIf="f1.Duration.errors.required"
										>This field is required!</small
									>
								</span>
							</div>
						</div>
						
					</fieldset>
									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px">Contact Details</h5>
										</legend>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="principalInvestigator"
													>Principal Investigator</label
												>
												<span class="required-asterisk">*</span>
												<input
													formControlName="PrincipalInvestigator"
													type="text"
													name="principalInvestigator"
													id="PprincipalInvestigator"
													class="form-control"
													[ngClass]="{
														'is-invalid':
															submitted && !f1.PrincipalInvestigator.valid
													}"
													placeholder="Principal Investigator"
												/>
												<span
													*ngIf="submitted && f1.PrincipalInvestigator.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.PrincipalInvestigator.errors.required"
														>This field is required!</small
													>
													<!-- <small
							class="form-text text-danger"
							*ngIf="f1.PrincipalInvestigator.errors.pattern"
							>This field contain atleast one alphanumerical
							value!</small
							> -->
												</span>
											</div>
											

											

											<div class="form-group col-md-4">
												<label class="form-label" for="gender"
													>Gender</label
												>
												<span class="required-asterisk">*</span>
									
												<ng-select
													[items]="gender"
													
													bindLabel="name"
													bindValue="id"
													[class.error]="
														!f1.Gender.valid && submitted
													"
													formControlName="Gender"
													placeholder="Gender"
													
													
												>
												</ng-select>
												<span
													*ngIf="submitted && f1.Gender.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Gender.errors.required"
														>This field is required!</small
													>
												</span>
											</div>

											<div class="form-group col-md-4">
												<label class="form-label" for="casteCategory"
													>Category</label
												>
												<span class="required-asterisk">*</span>
									
												<ng-select
													[items]="casteCategorylist"
													bindLabel="name"
													bindValue="id"
													placeholder="Category"
													[class.error]="
														!f1.casteCategory.valid && submitted
													"
													formControlName="casteCategory"	
												>
												</ng-select>
												<span
													*ngIf="submitted && f1.casteCategory.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.casteCategory.errors.required"
														>This field is required!</small
													>
												</span>
											</div>

											

											<div class="form-group col-8">
												<form
													[formGroup]="contactDetailsForm"
													*ngIf="contactDetailsForm"
												>
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th>Action</th>
																<th>Co-Principal Investigator(s)</th>
																<th>Contact No.</th>
															</tr>
														</thead>
														<tbody formArrayName="contactDetailsArray">
															<tr
																*ngFor="
																	let item of contactDetailsForm.controls
																		.contactDetailsArray.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteContactDetailRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td style="min-width: 120px">
																	<input
																		formControlName="CoPrincipalInvestigator"
																		type="text"
																		name="coPrincipalInvestigator"
																		id="coPrincipalInvestigator"
																		class="form-control"
																		placeholder="Co-Principal Investigator Name"
																		[ngClass]="{'is-invalid':contactDetailsForm.controls['contactDetailsArray'].controls[$index].controls['CoPrincipalInvestigator'].touched && contactDetailsForm.controls['contactDetailsArray'].controls[$index].controls['CoPrincipalInvestigator'].invalid}"/>
																	<span *ngIf="contactDetailsForm.controls['contactDetailsArray'].controls[$index].controls['CoPrincipalInvestigator'].invalid" 			class="invalid-form">
																		<small class="form-text text-danger" *ngIf="contactDetailsForm.controls['contactDetailsArray'].controls[$index].controls['CoPrincipalInvestigator'].touched && contactDetailsForm.controls['contactDetailsArray'].controls[$index].controls['CoPrincipalInvestigator'].hasError('required')">Required!</small>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				contactDetailsForm.controls[
																					'contactDetailsArray'
																				].controls[$index].controls[
																					'CoPrincipalInvestigator'
																				].touched && contactDetailsForm.controls['contactDetailsArray'].controls[$index].controls['CoPrincipalInvestigator'].hasError('pattern')">
																			Atleast one alphanumerical value is required!
																		</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		formControlName="CoPrincipalInvestigatorContactNo"
																		type="text"
																		name="contactNo"
																		id="contactNo"
																		class="form-control"
																		onKeyPress="if(this.value.length==15) return false;"
																		[mask]="'^([1-9]\\d*|0)$'"
																		placeholder="Co-Principal Investigator Contact No."
																		[ngClass]="{
																			'is-invalid':
																				contactDetailsForm.controls[
																					'contactDetailsArray'
																				].controls[$index].controls[
																					'CoPrincipalInvestigatorContactNo'
																				].touched &&
																				contactDetailsForm.controls[
																					'contactDetailsArray'
																				].controls[$index].controls[
																					'CoPrincipalInvestigatorContactNo'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			contactDetailsForm.controls[
																				'contactDetailsArray'
																			].controls[$index].controls[
																				'CoPrincipalInvestigatorContactNo'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				contactDetailsForm.controls[
																					'contactDetailsArray'
																				].controls[$index].controls[
																					'CoPrincipalInvestigatorContactNo'
																				].touched &&
																				contactDetailsForm.controls[
																					'contactDetailsArray'
																				].controls[$index].controls[
																					'CoPrincipalInvestigatorContactNo'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				contactDetailsForm.controls[
																					'contactDetailsArray'
																				].controls[$index].controls[
																					'CoPrincipalInvestigatorContactNo'
																				].touched &&
																				contactDetailsForm.controls[
																					'contactDetailsArray'
																				].controls[$index].controls[
																					'CoPrincipalInvestigatorContactNo'
																				].hasError('minlength')
																			"
																		>
																			Enter valid contact no.
																		</small>
																	</span>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addContactRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
										</div>
									</fieldset>
									

									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px">
												Implementing Organization(s) Details
											</h5>
										</legend>
										<div class="row">

											<div class="form-group col-md-4">
												<label
													class="form-label"
													for="principalImplementingOnganizations"
													>Principal Implementing Organization(s)</label
												>
												<span class="required-asterisk">*</span>
												<input
													formControlName="PrincipalImplementingOnganizations"
													type="text"
													name="principalImplementingOnganizations"
													placeholder="Principal Implementing Organization"
													id="principalImplementingOnganizations"
													class="form-control"
													[ngClass]="{
														'is-invalid':
															submitted &&
															!f1.PrincipalImplementingOnganizations.valid
													}"
												/>
												<span
													*ngIf="
														submitted &&
														f1.PrincipalImplementingOnganizations.invalid
													"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="
															f1.PrincipalImplementingOnganizations.errors
																.required
														"
														>This field is required!</small
													>
													<small
														class="form-text text-danger"
														*ngIf="
															f1.PrincipalImplementingOnganizations.errors
																.pattern
														"
														>This field contain atleast one alphanumerical
														value!</small
													>
												</span>
											</div>


											<div class="form-group col-md-4">
												<label class="form-label" for="categoryOfInstitution"
													>Category of the Implementing Institution(s)</label
												>
												<span class="required-asterisk">*</span>
												<ng-select
													[items]="categoryOfInstitution"
													bindLabel="categoryOfInstitutionName"
													bindValue="categoryOfInstitutionID"
													placeholder="Category of the Implementing Institution(s)"
													[class.error]="
														!f1.CategoryOfInstitution.valid && submitted
													"
													formControlName="CategoryOfInstitution"
													(change)="
														onOptionsSelected($event.categoryOfInstitutionName)
													"
												>
												</ng-select>
												<span
													*ngIf="submitted && f1.CategoryOfInstitution.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.CategoryOfInstitution.errors.required"
														>This field is required!</small
													>
												</span>
											</div>
										</div>
											<div class="row">
											<div class="form-group col-md-4">
												<label
													class="form-label"
													for="principalImplementingOnganizations"
													>Address</label
												>
												<span class="required-asterisk">*</span>

												<textarea
													formControlName="Address"
													type="text"
													name="address"
													id="address"
													class="form-control"
													style="height: 100px"
													[ngClass]="{
														'is-invalid': submitted && !f1.Address.valid
													}"
													placeholder="Address"
												></textarea>

												
												
												<span
													*ngIf="
														submitted &&
														f1.Address.invalid
													"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="
															f1.Address.errors
																.required
														"
														>This field is required!</small
													>
													<small
														class="form-text text-danger"
														*ngIf="
															f1.Address.errors
																.pattern
														"
														>This field contain atleast one alphanumerical
														value!</small
													>
												</span>
											</div>
											
											

											
											<div class="form-group col-md-4">
												<label class="form-label" for="state">State</label>
												<ng-select [items]="stateArray" bindLabel="stateName"
													bindValue="stateID" formControlName="State"
													placeholder="State"
													(change)="getCityDistrictDetails($event)" >
												</ng-select>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="district">District</label>
												<ng-select [items]="cityArray" bindLabel="districtName"
													bindValue="districtID" formControlName="District"
													placeholder="District" >
												</ng-select>
											</div>

											<div class="form-group col-md-4">
												<label
													class="form-label"
													for="pinCode"
													> Pin Code</label
												>
												<span class="required-asterisk">*</span>
												<input
													formControlName="PinCode"
													type="text"
													name="pincode" 
													placeholder="Pin Code"
													id="pincode"
													onKeyPress="if(this.value.length==6) return false;"
													[mask]="'^([1-9]\\d*|0)$'"
													class="form-control"
													[ngClass]="{
														'is-invalid':
															submitted &&
															!f1.PinCode.valid
													}"
												/>
												<span
													*ngIf="
														submitted &&
														f1.PinCode.invalid
													"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="
															f1.PinCode.errors
																.required
														"
														>This field is required!</small
													>
													<small
														class="form-text text-danger"
														*ngIf="
															f1.PinCode.errors
																.pattern
														"
														>This field contain atleast one alphanumerical
														value!</small
													>
												</span>
											</div>

										
												
									

											
										
											<div class="form-group col-md-4" *ngIf="displayField">
												<label class="form-label" for="darpanPortlRegisterID"
													>Darpan Portal RegistrationID</label
												>
												<span class="required-asterisk">*</span>
												<input
													formControlName="DarpanPortlRegisterID"
													type="text"
													name="darpanPortlRegisterID"
													id="darpanPortlRegisterID"
													class="form-control"
													[ngClass]="{
														'is-invalid':
															submitted && !f1.DarpanPortlRegisterID.valid
													}"
													placeholder="Darpan Portal Registration ID"
												/>
												<span
													*ngIf="submitted && f1.DarpanPortlRegisterID.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.DarpanPortlRegisterID.errors.required"
														>This field is required!</small
													>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="collaborating"
													>Collaborating Organizations
												</label>
												<span class="required-asterisk">*</span>
												<input
													formControlName="Collaborating"
													type="text"
													name="collaborating"
													id="collaborating"
													class="form-control"
													[ngClass]="{
														'is-invalid': submitted && !f1.Collaborating.valid
													}"
													placeholder="Collaborating/ Organizations "
												/>
												<sup
													>In case of multiple organizations, please write the
													name with comma separated</sup
												>
												<span
													*ngIf="submitted && f1.Collaborating.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Collaborating.errors.required"
														>This field is required!</small
													>
													<small
														class="form-text text-danger"
														*ngIf="f1.Collaborating.errors.pattern"
														>This field contain atleast one alphanumerical
														value!</small
													>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="shareofimplementing"
													>Share of implementing /participating Institutions in
													the total cost (Rs.)
													<span class="required-asterisk">*</span></label
												>
												<!-- curencyFormat -->
												<input
													formControlName="Shareofimplementing"
													type="text"
													curencyFormat
													name="shareofimplementing"
													id="shareofimplementing"
													class="form-control"
													[ngClass]="{
														'is-invalid':
															submitted && !f1.Shareofimplementing.valid
													}"
													[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
													onKeyPress="if(this.value.length==15) return false;"
													placeholder="Share of implementing /participating Institutions in the total cost "
												/>
												<span
													*ngIf="submitted && f1.Shareofimplementing.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Shareofimplementing.errors.required"
														>This field is required!</small
													>
												</span>
											</div>
										</div>
									</fieldset>

									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px">Cost Details</h5>
										</legend>
										<div class="row">
											<div class="form-group col-12">
												<form [formGroup]="totalCostForm" *ngIf="totalCostForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th>Action</th>
																<th>
																	Budget Details (Total Cost, MNRE Share,
																	Industry Share)
																</th>
																<th>Amount (Rs.)</th>
															</tr>
														</thead>
														<tbody formArrayName="costArray">
															<tr *ngFor="let item of totalCostForm.controls.costArray.controls;let $index = index"
																[formGroupName]="$index">
																<td>
																	<i class="fa fa-trash fa-2x" (click)="deleteRow($index)" title="Delete" style="cursor: pointer"></i>
																</td>
																<td style="min-width: 120px">
																	<ng-select
																		[items]="budgetType"
																		bindLabel="budgetTypeName"
																		bindValue="budgetTypeID"
																		(change)="validateRow($index)"
																		[class.error]="
																			totalCostForm.controls['costArray']
																				.controls[$index].controls['title']
																				.invalid && submitted
																		"
																		formControlName="title"
																		placeholder="Budget Cost Type"
																	>
																	</ng-select>
																	<span
																		*ngIf="
																			totalCostForm.controls['costArray']
																				.controls[$index].controls['title']
																				.invalid && submitted
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				totalCostForm.controls[
																					'costArray'
																				].controls[$index].controls[
																					'title'
																				].hasError('required')
																			"
																		>
																			Required!</small
																		>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<!-- [curencyFormat] -->
																	<input
																		class="form-control"
																		type="text"
																		curencyFormat
																		formControlName="value"
																		[ngClass]="{
																			'is-invalid':
																				totalCostForm.controls['costArray']
																					.controls[$index].controls['value']
																					.touched &&
																				totalCostForm.controls['costArray']
																					.controls[$index].controls['value']
																					.invalid
																		}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;" (change)="setAllFieldTotalCost($index)"
																	/>
																	<span *ngIf="totalCostForm.controls['costArray'].controls[$index].controls['value'].invalid"
																		class="invalid-form">
																		<small
																			class="form-text text-danger"
																			*ngIf="totalCostForm.controls['costArray'].controls[$index].controls['value'].touched &&
																				totalCostForm.controls['costArray'].controls[$index].controls['value'].hasError('required')">
																			Required!
																		</small>
																	</span>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">Total Cost</td>
																<td scope="col" class="text-wrap">{{ f1.totalCostValue.value }}</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
										</div>
									</fieldset>

									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px">About Project</h5>
										</legend>
										<div class="row">
											<div class="form-group col-md-6">
												<label class="form-label" for="objectives"
													>Objectives</label
												>
												<span class="required-asterisk">*</span>
												<textarea
													formControlName="Objectives"
													type="text"
													name="objectives"
													id="objectives"
													class="form-control"
													style="height: 200px"
													[ngClass]="{
														'is-invalid': submitted && !f1.Objectives.valid
													}"
													placeholder="Objectives"
												></textarea>
												<span
													*ngIf="submitted && f1.Objectives.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Objectives.errors.required"
														>This field is required!</small
													>
													<!-- <small class="form-text text-danger"
														*ngIf="f1.Objectives.errors.pattern">This field contain atleast one alphanumerical value!</small> -->
												</span>
											</div>
											<div class="form-group col-md-6">
												<label class="form-label" for="summary"
													>Summary (About a paragraph)</label
												>
												<span class="required-asterisk">*</span>
												<textarea
													formControlName="Summary"
													type="text"
													name="summary"
													id="summary"
													style="height: 200px"
													class="form-control"
													[ngClass]="{
														'is-invalid': submitted && !f1.Summary.valid
													}"
													placeholder="Summary"
												></textarea>
												<span
													*ngIf="submitted && f1.Summary.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.Summary.errors.required"
														>This field is required!</small
													>
													<!-- <small class="form-text text-danger"
														*ngIf="f1.Summary.errors.pattern">This field contain atleast one alphanumerical value!</small> -->
												</span>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-6">
												<label class="form-label" for="needOfTheProjectOutcome"
													>Need of the Project with proper assessment for
													viability of the product/ outcome<span
														class="required-asterisk"
														>*</span
													>
												</label>
												<textarea
													formControlName="NeedOfTheProjectOutcome"
													type="text"
													name="needOfTheProjectOutcome"
													id="needOfTheProjectOutcome"
													style="height: 200px"
													class="form-control"
													[ngClass]="{
														'is-invalid':
															submitted && !f1.NeedOfTheProjectOutcome.valid
													}"
													placeholder="Need of the Project with proper assessment for viability of the product/ outcome "
												></textarea>
												<span
													*ngIf="
														submitted && f1.NeedOfTheProjectOutcome.invalid
													"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.NeedOfTheProjectOutcome.errors.required"
														>This field is required!</small
													>
													<!-- <small class="form-text text-danger"
														*ngIf="f1.NeedOfTheProjectOutcome.errors.pattern">This field contain atleast one alphanumerical value!</small> -->
												</span>
											</div>
											<div class="form-group col-md-6">
												<label class="form-label" for="statusOfWork"
													>Status of Work being done in other
													National/International Institutions/ Industries<span
														class="required-asterisk"
														>*</span
													>
												</label>
												<textarea
													formControlName="StatusOfWork"
													type="text"
													name="statusOfWork"
													style="height: 200px"
													id="statusOfWork"
													class="form-control"
													[ngClass]="{
														'is-invalid': submitted && !f1.StatusOfWork.valid
													}"
													placeholder="Status of Work"
												></textarea>
												<span
													*ngIf="submitted && f1.StatusOfWork.invalid"
													class="invalid-form"
												>
													<small
														class="form-text text-danger"
														*ngIf="f1.StatusOfWork.errors.required"
														>This field is required!</small
													>
													<!-- <small class="form-text text-danger"
														*ngIf="f1.StatusOfWork.errors.pattern">This field contain atleast one alphanumerical value!</small> -->
												</span>
											</div>
										</div>
									</fieldset>

									<div
										class="d-flex justify-content-between"
										style="margin-top: 7px"
									>
										<button
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-outline-secondary btn-prev"
											disabled
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button
											(click)="submitStep1()"
											type="submit"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Save & Next</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button>
									</div>
								</form>
							</div>
							<div id="format2" class="content">
								<form [formGroup]="format2" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">Proposal Format - 2</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>

									<fieldset class="border" style="padding: 0.7rem">
										<legend class="w-auto">
											<h5 style="margin-top: 7px">Project Timeline</h5>
										</legend>
										<div class="row">
											<div class="form-group col-md-12">
												<form
													[formGroup]="projectPlanForm"
													*ngIf="projectPlanForm"
												>
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th>Action</th>
																<th>Task</th>
																<th>Duration (in Months)</th>
																<!-- <th>Start Date</th>
																<th>End Date</th> -->
															</tr>
														</thead>
														<tbody formArrayName="projectPlanArray">
															<tr
																*ngFor="
																	let item of projectPlanForm.controls
																		.projectPlanArray.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteProjectPlanRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="name"
																		[ngClass]="{
																			'is-invalid':
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls['name']
																					.touched &&
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls['name']
																					.invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			projectPlanForm.controls[
																				'projectPlanArray'
																			].controls[$index].controls['name']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls['name']
																					.touched &&
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls[
																					'name'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls['name']
																					.touched &&
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls[
																					'name'
																				].hasError('pattern')
																			"
																		>
																			Atleast one alphanumerical value is
																			required!
																		</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		[mask]="'^([1-9]\\d*|0)$'"
																		maxlength="4"
																		formControlName="duration"
																		[ngClass]="{
																			'is-invalid':
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls['duration']
																					.touched &&
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls['duration']
																					.invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			projectPlanForm.controls[
																				'projectPlanArray'
																			].controls[$index].controls['duration']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				projectPlanForm.controls[
																					'projectPlanArray'
																				].controls[$index].controls['duration']
																					.touched
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<!-- <td style="min-width: 120px;">
																	<div class="input-group">
																		<input class="form-control"
																			placeholder="dd-mm-yyyy"
																			name="startDate" formControlName="startDate"
																			ngbDatepicker #MinMaxDP="ngbDatepicker"
																			[ngClass]="{ 'is-invalid': projectPlanForm.controls['projectPlanArray'].controls[$index].controls['startDate'].touched
										&& projectPlanForm.controls['projectPlanArray'].controls[$index].controls['startDate'].invalid}"
																			[minDate]="$index > 0 ? setNextMinDate($index) : {year: maxDate.year, month: maxDate.month, day:maxDate.day}"
																			[maxDate]="$index > 0 ? setMaxDate($index) : ''"
																			[readonly]="true"/>
																		<div class="input-group-append">
																			<button
																				class="btn btn-outline-secondary feather icon-calendar"
																				(click)="setStartMinDate($index); MinMaxDP.toggle();"
																				type="button" rippleEffect></button>
																		</div>
																	</div>
																	<span
																		*ngIf="projectPlanForm.controls['projectPlanArray'].controls[$index].controls['startDate'].invalid"
																		class="invalid-form">
																		<small class="form-text text-danger"
																			*ngIf="projectPlanForm.controls['projectPlanArray'].controls[$index].controls['startDate'].touched &&
										projectPlanForm.controls['projectPlanArray'].controls[$index].controls['startDate'].hasError('required')">
																			Required!
																		</small>
																	</span>
																</td>
																<td style="min-width: 120px;">
																	<div class="input-group">
																		<input class="form-control"
																			placeholder="dd-mm-yyyy"
																			name="endDate" formControlName="endDate"
																			ngbDatepicker #MinMaxDP1="ngbDatepicker"
																			[ngClass]="{ 'is-invalid': projectPlanForm.controls['projectPlanArray'].controls[$index].controls['endDate'].touched
										&& projectPlanForm.controls['projectPlanArray'].controls[$index].controls['endDate'].invalid}"
																			[minDate]="setMinDate($index)"
																			[maxDate]="setMaxDate($index)"
																			[readonly]="true"/>
																		<div class="input-group-append">
																			<button
																				class="btn btn-outline-secondary feather icon-calendar"
																				type="button"
																				(click)=" setEndMinDate($index); MinMaxDP1.toggle();"
																				rippleEffect></button>
																		</div>
																	</div>
																	<span
																		*ngIf="projectPlanForm.controls['projectPlanArray'].controls[$index].controls['endDate'].invalid"
																		class="invalid-form">
																		<small class="form-text text-danger"
																			*ngIf="projectPlanForm.controls['projectPlanArray'].controls[$index].controls['endDate'].touched &&
										projectPlanForm.controls['projectPlanArray'].controls[$index].controls['endDate'].hasError('required')">
																			Required!
																		</small>
																	</span>
																</td> -->
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addProjectPlanRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
										</div>
										<!-- <div class="row">
											<div class="col-12">
												<section id="apex-bar-and-candlestick-charts">
													<div id="chart"
														*ngIf="chartOptions != null && chartOptions.series[0].data.length > 0">
														<apx-chart [series]="chartOptions.series"
															[chart]="chartOptions.chart"
															[plotOptions]="chartOptions.plotOptions"
															[xaxis]="chartOptions.xaxis"></apx-chart>
													</div>
													<div
														*ngIf="chartOptions != null && chartOptions.series[0].data.length == 0">
														<p>No Details are defined for the Project timelines.</p>
													</div>
												</section>
											</div>
										</div> -->
									</fieldset>

									<div
										class="row"
										id="table-responsive"
										style="margin-top: 5px"
									>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form
													[formGroup]="proposedCostForm"
													*ngIf="proposedCostForm"
												>
													<table class="table mb-0">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Proposed cost: (Details of equipment along
																	with justification to be provided separately
																	in the Format as per Annexure I)
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	SR. No.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Item
																</th>
																<th scope="col" class="text-wrap"  rowspan="2">
																	Total Cost
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="noOfYeararray.length"
																>
																	Amount (Rs.)
																</th>
															</tr>

															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
															</tr>
														</thead>
														 <tbody formArrayName="proposedCostArray">
															<tr *ngFor="let item of proposedCostForm.controls.proposedCostArray.controls;let $index = index" [formGroupName]="$index">
																<td *ngIf="$index == 0" [attr.rowspan]="proposedCostForm.controls.proposedCostArray.length"></td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td scope="col" class="text-wrap">
																	<span>{{
																		proposedCostForm.controls[
																			"proposedCostArray"
																		].controls[$index].controls[
																			"proposedCostItemName"
																		].value
																	}}</span>
																</td>
																<td scope="col" class="text-wrap">
																	<input
																		type="hidden"
																		formControlName="proposedCostItemID"
																	/>
																	<span>{{
																		proposedCostForm.controls[
																			"proposedCostArray"
																		].controls[$index].controls["totalCost"]
																			.value
																	}}</span>
																</td>
																<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text"
																		curencyFormat
																		formControlName="{{y.label}}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																		(change)="setAllFieldTotal($index)"
																	/>
																	
																</td>
														<tr>
															<td style="border-top: none"></td>
															<td scope="col" class="text-wrap">Total</td>
															<td scope="col" class="text-wrap"></td>
															<td scope="col" class="text-wrap">
																<span>{{ f2.allTotalCost.value }}</span>
															</td>
															<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
																<span>{{y.proposedCostTotal}}</span>
															</td>
														</tr>
													</table>
												</form>
												<table class="table">
													<tbody>
														<tr>
															<td scope="col" class="text-wrap">
																Project Deliverables
																(products/process/papers/IPR)
															</td>
															<td scope="col" class="text-wrap" colspan="3">
																<textarea
																	type="text"
																	formControlName="ProjectDeliverables"
																	name="projectDeliverables"
																	id="projectDeliverables"
																	style="height: 150px"
																	class="form-control"
																	[ngClass]="{
																		'is-invalid':
																			submitted &&
																			f2.ProjectDeliverables.invalid
																	}"
																	placeholder="Project Deliverables"
																>
																</textarea>
																<span
																	*ngIf="
																		submitted && f2.ProjectDeliverables.invalid
																	"
																	class="invalid-form"
																>
																</span>
															</td>
														</tr>
														<!-- <tr>
															<td>Timelines (in terms of Work Plan)</td>
															<td scope="col" class="text-wrap" colspan="2">
																<input class="form-control" type="text"
																	formControlName="Timelines" name="timelines"
																	id="timelines" class="form-control" />
															</td>
														</tr> -->
														<tr>
															<td scope="col" class="text-wrap">
																Potential Users and suggested Plan of action for
																utilization of expected Project Output with
																proper analysis for scalability and bankability
															</td>
															<td scope="col" class="text-wrap" colspan="3">
																<textarea
																	type="text"
																	formControlName="PotentialUsersAndSuggestedPlan"
																	name="PotentialUsersAndSuggestedPlan"
																	id="potentialUsersAndSuggestedPlan"
																	style="height: 150px"
																	class="form-control"
																	[ngClass]="{
																		'is-invalid':
																			submitted &&
																			f2.PotentialUsersAndSuggestedPlan.invalid
																	}"
																	placeholder="Potential Users And Suggested Plan"
																>
																</textarea>
																<span
																	*ngIf="
																		submitted &&
																		f2.PotentialUsersAndSuggestedPlan.invalid
																	"
																	class="invalid-form"
																>
																	<!-- <small
									class="form-text text-danger"
									*ngIf="
										f2.PotentialUsersAndSuggestedPlan.errors
										.pattern
									"
									>This field contain atleast one
									alphanumerical value!</small
									> -->
																</span>
															</td>
														</tr>
														<tr>
															<td scope="col" class="text-wrap" colspan="3">
																<b>Other Information</b>
															</td>
														</tr>
														<tr>
															<td scope="col" class="text-wrap">
																Certificate from the Principal Investigator and Grantee organization &nbsp;&nbsp;
																<span>
																	<a href="{{documentURL}}/documentUploads/ImportantDocs/RnD_format_for_submission_of_proposal.pdf" target="_blank">
																		Download Format
																	</a>
																</span>
															</td>
															<td>
																<input
																	class="form-control"
																	type="text"
																	formControlName="CertificateRemarks"
																	id="certificateRemarks"
																	class="form-control"
																	[ngClass]="{
																		'is-invalid':
																			submitted && f2.CertificateRemarks.invalid
																	}"
																/>
																<span
																	*ngIf="
																		submitted && f2.CertificateRemarks.invalid
																	"
																	class="invalid-form"
																>
																</span>
															</td>
															<td>
																<div class="custom-file">
																	<input
																		type="file"
																		class="custom-file-input"
																		type="file"
																		ng2FileSelect
																		[uploader]="uploader"
																		id="file-upload-single"
																		(click)="
																			browsbuttonClick(
																				'investigatorGranteeOrgFile'
																			)
																		"
																		(change)="
																			onFileChange($event,'investigatorGranteeOrgFile',0,25)
																		"
																	/>
																	<label
																		class="custom-file-label"
																		id="SOELatter"
																		for="file-upload-single"
																		>{{ f2.CertificateFileName.value }}</label
																	>
																</div>
																<sup>(Upload PDF, Excel, word of size upto 25MB)</sup>
															</td>
									<td *ngIf="(f2?.CertificateFile.value != '')">
									<a href="{{f2?.CertificateFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td>
														</tr>
														<tr>
															<td scope="col" class="text-wrap">
																Infrastructural facilities available at the host
																institution (e.g. Telecommunication, Internet,
																Electrical/ Mechanical Workshop,
																Laboratoryspace, power supply including back up
																arrangement,etc.)
															</td>
															<td>
																<input
																	class="form-control"
																	type="text"
																	formControlName="InfrastructuralFacilites"
																	id="infrastructuralFacilites"
																	[ngClass]="{
																		'is-invalid':
																			submitted &&
																			f2.InfrastructuralFacilites.invalid
																	}"
																	class="form-control"
																/>
																<span
																	*ngIf="
																		submitted &&
																		f2.InfrastructuralFacilites.invalid
																	"
																	class="invalid-form"
																>
																	<!-- <small
									class="form-text text-danger"
									*ngIf="
										f2.InfrastructuralFacilites.errors.pattern
									"
									>This field contain atleast one
									alphanumerical value!</small
									> -->
																</span>
															</td>
															<td>
																<div class="custom-file">
																	<input
																		type="file"
																		class="custom-file-input"
																		type="file"
																		ng2FileSelect
																		[uploader]="uploader"
																		id="file-upload-single"
																		(click)="browsbuttonClick('hostInstitutionFile')"
																		(change)="onFileChange($event,'hostInstitutionFile',0,25)"
																	/>
																	<label
																		class="custom-file-label"
																		id="SOELatter"
																		for="file-upload-single"
																		>{{
																			f2.InfrastructuralFacilitesFileName.value
																		}}</label
																	>
																</div>
																<sup>(Upload PDF, Excel, word of size upto 25MB)</sup>
															</td>
							 	<td *ngIf="(f2?.InfrastructuralFacilitesFile.value != '')">
									<a href="{{f2?.InfrastructuralFacilitesFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td>
														</tr>
														<tr>
								<td scope="col" class="text-wrap">
									CVs of PI and all co PIs, which would include
									details of other R&D projects implemented, their
									cost, status (completed/ under implementation)
									and sponsors.
								</td>
								<td>
									<input
									class="form-control"
									type="text"
									formControlName="CSVOfPIRemarks"
									id="cSVOfPIRemarks"
									[ngClass]="{
										'is-invalid':
										submitted && f2.CSVOfPIRemarks.invalid
									}"
									class="form-control"
									/>
									<span
									*ngIf="submitted && f2.CSVOfPIRemarks.invalid"
									class="invalid-form"
									>
									<!-- <small
										class="form-text text-danger"
										*ngIf="f2.CSVOfPIRemarks.errors.pattern"
										>This field contain atleast one
										alphanumerical value!</small
									> -->
									</span>
								</td>
								<td>
									<div class="custom-file">
									<input
										type="file"
										class="custom-file-input"
										type="file"
										ng2FileSelect
										[uploader]="uploader"
										id="file-upload-single"
										(click)="browsbuttonClick('costStatusFile')"
										(change)="
										onFileChange($event, 'costStatusFile', 0, 25)
										"
									/>
									<label
										class="custom-file-label"
										id="SOELatter"
										for="file-upload-single"
										>{{ f2.CSVOfPIFileName.value }}</label
									>
									</div>
									<sup>(Upload PDF, Excel, word of size upto 25MB)</sup>
								</td>
								<td *ngIf="(f2?.CSVOfPIFile.value != '')">
									<a href="{{f2?.CSVOfPIFile.value}}"
										target="_blank"><i
											class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="form-group col-md-4">
							<label for="file-upload-single"
								>Details of Research Methodology and Detailed Project Report (DPR), if any
							</label>
							<div class="custom-file">
								<input type="file" class="custom-file-input"
								type="file"
								ng2FileSelect
								[uploader]="uploader"
								id="file-upload-single"
								(click)="browsbuttonClick('researchMethodologyFile')"
								(change)="
									onFileChange($event, 'researchMethodologyFile', 0, 100)
								"
								/>
								<label
								class="custom-file-label"
								id="SOELatter"
								for="file-upload-single"
								>{{ f2.DetailofReserchFileName.value }}</label
								>

							</div>
							<sup>(Upload PDF, Excel, word of size upto 100MB)</sup>
					 </div>
					 <div class="form-group col-md-2 download-top" style="margin-top: 20px;">
						<div *ngIf="(f2?.DetailofReserchFile.value != '')">
							<a href="{{f2?.DetailofReserchFile.value}}" target="_blank"><i
								class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
								title="Download Document"></i></a>
						</div>
					 </div>
									</div>
									<div class="d-flex justify-content-between">
										<button
											type="button"
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button
											(click)="submitStep2()"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Save & Next</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button>
									</div>
								</form>
							</div>
							<div id="format3" class="content">
								<form [formGroup]="format3" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">
											Details of Costs of Various Components and Justification
										</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>
									<div class="row" id="table-responsive">
										<span class="mb-2">a). Cost of Equipment</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="equipmentForm" *ngIf="equipmentForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap">Action</th>
																<th scope="col" class="text-wrap">Sr.</th>
																<th scope="col" class="text-wrap">
																	Name of the Equipment along with make & model
																</th>
																<th scope="col" class="text-wrap">
																	Imported/ Indigenous
																</th>
																<th scope="col" class="text-wrap">
																	Estimated Costs (in INR Currency also for
																	imported equipment)*
																</th>
																<th scope="col" colspan="2" class="text-wrap">
																	Justification
																</th>
															</tr>
														</thead>
														<tbody formArrayName="equipmentArray">
															<tr
																*ngFor="
																	let item of equipmentForm.controls
																		.equipmentArray.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteEquipmentRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="equipmentName"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'equipmentName'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'equipmentName'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'equipmentName'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'equipmentName'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'equipmentName'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="importedIndigenous"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'importedIndigenous'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'importedIndigenous'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'importedIndigenous'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'importedIndigenous'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'importedIndigenous'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="estimatedCost"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].invalid
																		}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'estimatedCost'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'estimatedCost'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'estimatedCost'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			equipmentForm.controls['equipmentArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				equipmentForm.controls['equipmentArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										equipmentForm.controls['equipmentArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				equipmentForm.controls[
																					'equipmentArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td scope="col" class="text-wrap">
																	<div class="custom-file">
																		<input
																			type="file"
																			class="custom-file-input"
																			type="file"
																			ng2FileSelect
																			[uploader]="uploader"
																			id="file-upload-single"
																			formControlName="file"
																			(click)="
																				browsArrayFileObject(
																					'costEquipmentFileList',
																					$index
																				)
																			"
																			(change)="
																				onFileChange($event,'costEquipmentFileList',$index,25)
																			"
																		/>
																		<label
																			class="custom-file-label"
																			id="SOELatter"
																			for="file-upload-single"
																			>{{
																				equipmentForm.controls["equipmentArray"]
																					.controls[$index].controls["fileName"]
																					.value
																			}}</label
																		>
																	</div>
																</td>
																<td *ngIf="(equipmentForm.controls['equipmentArray'].controls[$index].controls['costEquipmentFile'].value != '')">
																	<a href="{{equipmentForm.controls['equipmentArray'].controls[$index].controls['costEquipmentFile'].value}}" target="_blank"><i
																		class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
																		title="Download Document"></i></a>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addEquipmentRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
											<span
												>*Including transport, insurance and installation
												charges.</span
											>
										</div>
									</div>

									<div class="row" id="table-responsive">
										<span class="mb-2">b). Manpower Cost</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="manpowerForm" *ngIf="manpowerForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Action
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Sr.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Designation/ Numbers
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Justification
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Monthly Salary
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="dynamicColumnCount"
																>
																	Amount (Rs.)
																</th>
																<!-- <th scope="col" class="text-wrap" rowspan="2"></th> -->
															</tr>
															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
																<th scope="col" class="text-wrap">
																	Total
																</th>
															</tr>
														</thead>
														<tbody formArrayName="manpowerArray">
															<tr
																*ngFor="
																	let item of manpowerForm.controls
																		.manpowerArray.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteManpowerRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="designation"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'designation'
																				].touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'designation'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls[
																				'designation'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'designation'
																				].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'designation'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										manpowerForm.controls['manpowerArray']
											.controls[$index].controls[
											'designation'
										].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'designation'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										manpowerForm.controls['manpowerArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="monthlyEmoluments"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'monthlyEmoluments'
																				].touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'monthlyEmoluments'
																				].invalid
																		}"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																		
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls[
																				'monthlyEmoluments'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls[
																					'monthlyEmoluments'
																				].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'monthlyEmoluments'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										manpowerForm.controls['manpowerArray']
											.controls[$index].controls[
											'monthlyEmoluments'
										].touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'monthlyEmoluments'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="{{y.label}}"
																		(change)="setManPowerYearTotal($index)"
																		[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																</td>
																<!-- <td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="year2"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year2']
																					.touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year2']
																					.invalid
																		}"
																		(change)="setManPowerYearTotal($index)"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls['year2']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year2']
																					.touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'year2'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="year3"
																		[ngClass]="{
																			'is-invalid':
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year3']
																					.touched &&
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year3']
																					.invalid
																		}"
																		(change)="setManPowerYearTotal($index)"
																		[mask]="
																			'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'
																		"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																	<span
																		*ngIf="
																			manpowerForm.controls['manpowerArray']
																				.controls[$index].controls['year3']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				manpowerForm.controls['manpowerArray']
																					.controls[$index].controls['year3']
																					.touched &&
																				manpowerForm.controls[
																					'manpowerArray'
																				].controls[$index].controls[
																					'year3'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td> -->
																<td style="min-width: 120px">
																	<span>{{
																		manpowerForm.controls["manpowerArray"]
																			.controls[$index].controls["total"].value
																	}}</span>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addManpowerRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
											<!-- <span>*Man months to be given within brackets before the budget amount.</span> -->
										</div>
									</div>

									<div class="row" id="table-responsive">
										<span class="mb-2">c). Cost of Consumables</span>
										<div class="form-group col-12">
											<div class="table-bordered">
												<form [formGroup]="consumablesForm" *ngIf="consumablesForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Action
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Sr.
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Item
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Quantity
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	rowspan="2"
																>
																	Unit
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="noOfYeararray.length"
																>
																	Amount (Rs.)
																</th>
															</tr>
															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
																<!-- <th scope="col" class="text-wrap">Total</th> -->
															</tr>
														</thead>
														<tbody formArrayName="consumablesArray">
															<tr *ngFor="
															let item of consumablesForm.controls
																.consumablesArray?.controls;
															let $index = index
														"
														[formGroupName]="$index">
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteConsumablesRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="item"
																		[ngClass]="{
																			'is-invalid':
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['item']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'item'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
								<small
								class="form-text text-danger"
								*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['item']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'item'
																				].hasError('pattern')
																			"
							>
								Atleast one alphanumerical value is
								required!
							</small>
																	</span>
																</td>
																<td>
																	<input
																		class="form-control"
																		type="text"
																		formControlName="qty"
																		[ngClass]="{
																			'is-invalid':
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['qty']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['qty']
																					.invalid
																		}"
																		maxlength="10"
																		[mask]="'^([1-9]\\d*|0)$'"
																	/>
																	<span
																		*ngIf="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['qty']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls['qty']
																					.touched &&
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'qty'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																	</span>
																</td>
																<td style="min-width: 250px">
																	<ng-select
																		[items]="unitsType"
																		bindLabel="unitsTypeName"
																		bindValue="unitsTypeID"
																		[class.error]="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['unit']
																				.invalid
																		"
																		(change)="setUnitName($index)"
																		formControlName="unit"
																		placeholder="Unit Type"
																	>
																	</ng-select>
																	<span
																		*ngIf="
																			consumablesForm.controls[
																				'consumablesArray'
																			].controls[$index].controls['unit']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				consumablesForm.controls[
																					'consumablesArray'
																				].controls[$index].controls[
																					'unit'
																				].hasError('required')
																			"
																		>
																			Required!</small
																		>
																	</span>
																</td>
																<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text"
																		curencyFormat
																		formControlName="{{y.label}}"
																		[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																		onKeyPress="if(this.value.length==15) return false;"
																		(change)="setConsumablesFormFieldTotal()"
																	/>
																	
																</td>
															</tr>
														</tbody>
														<tr>
															<td scope="col">
																<i
																	class="fa fa-plus fa-2x"
																	(click)="addConsumablesRow()"
																	title="Add"
																	style="cursor: pointer"
																></i>
															</td>
															<td scope="col" class="text-wrap"></td>
															<td
																scope="col"
																colspan="3"
																class="text-wrap"
																style="text-align: right"
															>
																Total
															</td>
															<td scope="col" class="text-wrap" *ngFor="let y of noOfYeararray">
																<span>{{y.costofConsumableTotal}}</span>
															</td>
														</tr>
													</table>
												</form>
											</div>
										</div>
									</div>

									<div class="d-flex justify-content-between">
										<button
											type="button"
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<button
											(click)="submitStep3()"
											class="btn btn-primary btn-next"
											rippleEffect
										>
											<span class="align-middle d-sm-inline-block d-none"
												>Save & Next</span
											>
											<i
												data-feather="arrow-right"
												class="align-middle ml-sm-25 ml-0"
											></i>
										</button>
									</div>
								</form>
							</div>
							<div id="format4" class="content">
								<form [formGroup]="format4" autocomplete="off">
									<div class="content-header">
										<h5 class="mb-0">Proposal Format - 4</h5>
										<small class="text-muted">Fill-up the Details.</small>
									</div>
									<div class="row" id="table-responsive">
										<span class="mb-2">d). Travel Cost</span>
										<div class="form-group col-12">
											<div class="table-responsive table-bordered">
												<form [formGroup]="travelForm" *ngIf="travelForm">
													<table class="table table-striped table-bordered">
														<thead>
															<tr>
																<th scope="col" class="text-wrap" rowspan="2">
																	Action
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Sr.
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Travel (Domestic/ International)
																</th>
																<th scope="col" class="text-wrap" rowspan="2">
																	Justification
																</th>
																<th
																	scope="col"
																	class="text-wrap"
																	style="text-align: center"
																	[attr.colspan]="dynamicColumnCount"
																>
																	Amount (Rs.)
																</th>
															</tr>
															<tr>
																<th scope="col" class="text-wrap"  *ngFor="let y of noOfYeararray">
																	{{y.key}}
																</th>
																<th scope="col" class="text-wrap">Total</th>
															</tr>
														</thead>
														<tbody formArrayName="travelArray">
															<tr
																*ngFor="
																	let item of travelForm.controls.travelArray
																		.controls;
																	let $index = index
																"
																[formGroupName]="$index"
															>
																<td>
																	<i
																		class="fa fa-trash fa-2x"
																		(click)="deleteTravelRow($index)"
																		title="Delete"
																		style="cursor: pointer"
																	></i>
																</td>
																<td scope="col" class="text-wrap">
																	{{ $index + 1 }}.
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="title"
																		[ngClass]="{
																			'is-invalid':
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.touched &&
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			travelForm.controls['travelArray']
																				.controls[$index].controls['title']
																				.invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				travelForm.controls['travelArray']
																					.controls[$index].controls['title']
																					.touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'title'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										travelForm.controls['travelArray']
											.controls[$index].controls['title']
											.touched &&
											travelForm.controls[
											'travelArray'
											].controls[$index].controls[
											'title'
											].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px">
																	<input
																		class="form-control"
																		type="text"
																		formControlName="justification"
																		[ngClass]="{
																			'is-invalid':
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].invalid
																		}"
																	/>
																	<span
																		*ngIf="
																			travelForm.controls['travelArray']
																				.controls[$index].controls[
																				'justification'
																			].invalid
																		"
																		class="invalid-form"
																	>
																		<small
																			class="form-text text-danger"
																			*ngIf="
																				travelForm.controls['travelArray']
																					.controls[$index].controls[
																					'justification'
																				].touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('required')
																			"
																		>
																			Required!
																		</small>
																		<small
										class="form-text text-danger"
										*ngIf="
										travelForm.controls['travelArray']
											.controls[$index].controls[
											'justification'
										].touched &&
																				travelForm.controls[
																					'travelArray'
																				].controls[$index].controls[
																					'justification'
																				].hasError('pattern')
										"
									>
										Atleast one alphanumerical value is
										required!
									</small>
																	</span>
																</td>
																<td style="min-width: 120px" *ngFor="let y of noOfYeararray; let $index1 = index1">
																	<input
																		class="form-control"
																		type="text" curencyFormat
																		formControlName="{{y.label}}"
																		(change)="setTravelCostTotal($index)"
																		[mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
																		onKeyPress="if(this.value.length==15) return false;"
																	/>
																</td>
																<td style="min-width: 120px">
																	<span>{{
																		travelForm.controls["travelArray"].controls[
																			$index
																		].controls["total"].value
																	}}</span>
																</td>
															</tr>
															<tr>
																<td>
																	<i
																		class="fa fa-plus fa-2x"
																		(click)="addTravelRow()"
																		title="Add"
																		style="cursor: pointer"
																	></i>
																</td>
															</tr>
														</tbody>
													</table>
												</form>
											</div>
										</div>
									</div>
									<div class="d-flex justify-content-between">
										<button
											type="button"
											(click)="horizontalWizardStepperPrevious()"
											class="btn btn-primary btn-prev"
											rippleEffect
										>
											<i
												data-feather="arrow-left"
												class="align-middle mr-sm-25 mr-0"
											></i>
											<span class="align-middle d-sm-inline-block d-none"
												>Previous</span
											>
										</button>
										<!-- <button (click)="horizontalWizardStepperNext(format4)" class="btn btn-primary btn-next"
						rippleEffect>
						<span class="align-middle d-sm-inline-block d-none">Save & Next</span>
						<i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
					</button> -->
										<button
											class="btn btn-success btn-submit"
											[disabled]="isDisabled"
											rippleEffect
											(click)="onSubmit()"
										>
											Submit
										</button>
									</div>
								</form>
							</div>
							<!-- <div id="format5" class="content">
				<form [formGroup]="format5" autocomplete="off" (ngSubmit)="onSubmit()">
					<div class="content-header">
					<h5 class="mb-0">Certificate from the Principal Investigator and Grantee organization (On the letter
						head of the Organization)</h5>
					</div>
					<div class="row">
					<div class="form-group col-md-6"></div>
					<div class="form-group col-md-6"></div>
					</div>
					<div class="d-flex justify-content-between">
					<button type="button" (click)="horizontalWizardStepperPrevious()" class="btn btn-primary btn-prev"
						rippleEffect>
						<i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
						<span class="align-middle d-sm-inline-block d-none">Previous</span>
					</button>
					<button class="btn btn-success btn-submit" rippleEffect (click)="onSubmit()">Submit</button>
					</div>
				</form>
				</div> -->
						</div>
					</div>
				</div>
			<!-- </div> -->
		</section>
	</div>
</div>
